import type { FileType } from '@prisma/client';

const ATTACHABLE_FILE_TYPES = ['CSV', 'GIF', 'JPEG', 'JPG', 'PDF', 'PNG', 'RTF', 'TXT', 'WEBP'] as const satisfies readonly FileType[];

type ChatAttachableFileType = (typeof ATTACHABLE_FILE_TYPES)[number];

export const CHAT_ATTACHABLE_FILE_TYPES: FileType[] = [...ATTACHABLE_FILE_TYPES];

export const CHAT_FILE_MEDIA_TYPES: Record<ChatAttachableFileType, string> = {
	CSV: 'text/csv',
	GIF: 'image/gif',
	JPEG: 'image/jpeg',
	JPG: 'image/jpeg',
	PDF: 'application/pdf',
	PNG: 'image/png',
	RTF: 'application/rtf',
	TXT: 'text/plain',
	WEBP: 'image/webp',
};

export const isChatAttachableFileType = (fileType: FileType): fileType is ChatAttachableFileType => fileType in CHAT_FILE_MEDIA_TYPES;

export const CHAT_DOCUMENT_SELECTION_LIMIT = 10;
